const CityHallMapper = () => import(/* webpackChunkName: "admin_city_hall_mapper" */ '@/components/admin/CityHallMapper')
const CityHallMapperIndex = () => import(/* webpackChunkName: "admin_city_hall_mapper" */ '@/components/admin/city_hall_mapper/Index')
const CityHallMapperConsult = () => import(/* webpackChunkName: "admin_city_hall_mapper" */ '@/components/admin/city_hall_mapper/Consult')
const CityHallMapperEvent = () => import(/* webpackChunkName: "admin_city_hall_mapper" */ '@/components/admin/city_hall_mapper/Event')

export default {
  children: [
    {
      component: CityHallMapperIndex,
      meta: {
        breadcrumbs: [
          { link: '/admin', name: 'Administração' },
          { name: 'CityHallMapper' },
        ]
      },
      path: '/',
    },
    {
      component: CityHallMapperConsult,
      meta: {
        breadcrumbs: [
          { link: '/admin', name: 'Administração' },
          { link: '/admin/city_hall_mapper', name: 'CityHallMapper' },
          { name: 'Consultas' },
        ]
      },
      path: 'consults',
    },
    {
      component: CityHallMapperEvent,
      meta: {
        breadcrumbs: [
          { link: '/admin', name: 'Administração' },
          { link: '/admin/city_hall_mapper', name: 'CityHallMapper' },
          { name: 'Eventos' },
        ]
      },
      path: 'events',
    }
  ],
  component: CityHallMapper,
  path: 'city_hall_mapper'
}